import React from 'react';

import { theme, Typography } from 'antd';

import sessionManager, { eVariableType } from '../SessionManager';
import './Magazzino.css';
import MenuMagazzinoClienti from './MagazzinoClienti/MenuMagazzinoClienti';

const { useToken } = theme;

type HeaderBarPars = {
    descrizione?: string;
    menuSelezionato: string;
};

export default function HeaderBar(par: HeaderBarPars) {
    const { token } = useToken();

    function CheckImage(path) {
        const img = new Image();
        img.src = path;

        if (img.complete) return true;

        return false;
    }

    return (
        <div style={{ paddingTop: '20px' }}>
            <div className="headerbar" style={{ background: token.colorPrimary, display: 'flex', flexWrap: 'wrap' }}>
                {CheckImage('custom/logosocieta.png') ? (
                    <img height={30} style={{ marginRight: '20px' }} alt="" src="custom/logosocieta.png"></img>
                ) : null}
                <Typography.Text className="testotitolopiccolo">
                    {sessionManager.get(eVariableType.RagioneSociale)} - {par.descrizione}
                </Typography.Text>

                <MenuMagazzinoClienti currentMenu={par.menuSelezionato}></MenuMagazzinoClienti>
            </div>
        </div>
    );
}
